const ExampleBox = ({ title, content }) => {
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden border border-gray-200">
      <h3 className="bg-[#048998] text-white p-4 text-xl">
        {title}
      </h3>
      <div className="p-5">
        {content}
      </div>
    </div>
  );
};


export default ExampleBox;